import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-save-bim-offset-dialog',
  templateUrl: './save-bim-offset-dialog.component.html',
  styleUrls: ['./save-bim-offset-dialog.component.scss'],
})
export class SaveBimOffsetDialogComponent implements OnInit {
  is_checked: boolean = false;

  constructor(private _dialogRef: MatDialogRef<SaveBimOffsetDialogComponent>) {}

  ngOnInit(): void {}

  onNoClick() {
    this._dialogRef.close();
  }

  onSave() {
    this._dialogRef.close({ is_default: this.is_checked });
  }
}
